import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-menu" }
const _hoisted_2 = ["href"]

import IconSpeedMeter from '../assets/icons/IconSpeedMeter.vue'
import IconLineChart from '../assets/icons/IconLineChart.vue'
import IconLayoutGrid from '../assets/icons/IconLayoutGrid.vue'
import IconExternalLInk from '../assets/icons/IconExternalLink.vue'
import TooltipStandardV2 from '../atoms/TooltipStandardV2.vue'

import { useI18n } from 'vue-i18n'

type Emits = (e: 'toggle', toggleData: string) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleMenu',
  props: {
    enabledButtons: {},
    selected: {},
    link: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()



const emits = __emit

function toggle(toggleData: string) {
  emits('toggle', toggleData)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.enabledButtons.includes('timeseries'))
      ? (_openBlock(), _createBlock(TooltipStandardV2, {
          key: 0,
          text: _unref(t)('general__text__all_types_of_data_visualization'),
          arrowPosition: 'top-center',
          verticalOffset: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", { active: _ctx.selected.includes('all') }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle('all')))
            }, _toDisplayString(_unref(t)('general__text__all')), 3)
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.enabledButtons.includes('timeseries'))
      ? (_openBlock(), _createBlock(TooltipStandardV2, {
          key: 1,
          text: _unref(t)('dashboard__text__measurement_values'),
          arrowPosition: 'top-center',
          verticalOffset: 2
        }, {
          default: _withCtx(() => [
            _createVNode(IconSpeedMeter, {
              class: _normalizeClass(["badge", { active: _ctx.selected.includes('measurement') }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggle('measurement')))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.enabledButtons.includes('timeseries'))
      ? (_openBlock(), _createBlock(TooltipStandardV2, {
          key: 2,
          text: _unref(t)('dashboard__text__chart-graphs'),
          arrowPosition: 'top-center',
          verticalOffset: 2
        }, {
          default: _withCtx(() => [
            _createVNode(IconLineChart, {
              class: _normalizeClass(["badge", { active: _ctx.selected.includes('graphs') }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggle('graphs')))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.enabledButtons.includes('heatmap'))
      ? (_openBlock(), _createBlock(TooltipStandardV2, {
          key: 3,
          text: _unref(t)('dashboard__text__chart-heatmaps'),
          arrowPosition: 'top-center',
          verticalOffset: 2
        }, {
          default: _withCtx(() => [
            _createVNode(IconLayoutGrid, {
              class: _normalizeClass(["badge", { active: _ctx.selected.includes('heatmap') }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggle('heatmap')))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.link && _ctx.link.name)
      ? (_openBlock(), _createBlock(TooltipStandardV2, {
          key: 4,
          text: _ctx.link.name,
          arrowPosition: 'top-center',
          verticalOffset: 2
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "a-href",
              href: _ctx.link.address,
              target: "_blank",
              rel: "noreferrer noopener"
            }, [
              _createVNode(IconExternalLInk, { class: "badge" })
            ], 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})